import type maplibregl from 'maplibre-gl';
import React, { useEffect, useRef } from 'react';
import { type VehicleType } from '../../model/VehicleType';

export interface PopupContent {
  type: VehicleType;
  label: string;
  trip_headsign?: string;
  stop_name: string;
  arrival_time: string;
  delay: string;
  isOffline: boolean;
}

interface VehiclePopupProps {
  visible: boolean;
  lngLat: [number, number];
  map: maplibregl.Map | null;
  content: PopupContent | undefined;
}

const VehiclePopup: React.FC<VehiclePopupProps> = ({ visible, lngLat, map, content }) => {
  const popupRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if ((popupRef.current == null) || map === null) return;

    const updatePosition = () => {
      const position = map.project(lngLat);
      if (!visible && popupRef.current !== null) {
        popupRef.current.style.left = '0px';
        popupRef.current.style.top = '0px';
      } else if (popupRef.current !== null) {
        popupRef.current.style.left = `${position.x}px`;
        popupRef.current.style.top = `${position.y - 20}px`;
      }
    };

    updatePosition();
    map.on('move', updatePosition);

    return () => {
      map.off('move', updatePosition);
    };
  }, [lngLat, map, visible]);

  return (
    <div
      ref={popupRef}
      style={{
        position: 'absolute',
        visibility: visible ? 'visible' : 'hidden',
        background: 'white',
        padding: '5px',
        borderRadius: '5px',
        width: '210px',
        boxShadow: '0 0 5px rgba(0,0,0,0.3)',
        transform: 'translate(-50%, -100%)'
      }}
    >
      {content?.label === '' ? 'Chargement...' : <>
        <b>{content?.type === 'bus' ? 'Bus ' : 'Tram '}{content?.label} → {content?.trip_headsign}</b><br />
        Prochain arrêt: <b>{content?.stop_name}</b><br />
        Arrivée Estimée: <b>{content?.arrival_time}</b> {content?.delay !== '(0 min)' ? content?.delay : ''}
      </>}
    </div>
  );
};

export default VehiclePopup;
